import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    game_launch_language_list: [
        {
            language_code: "en",
            language_name: "English"
        },
        {
            language_code: "ko",
            language_name: "Korean"
        },
        {
            language_code: "thai",
            language_name: "Thai"
        },
        {
            language_code: "vi",
            language_name: "Vietnamese"
        },
        {
            language_code: "ja",
            language_name: "Japanese"
        },
        {
            language_code: "zh",
            language_name: "Chinese"
        },
        {
            language_code: "id",
            language_name: "Indonesian"
        },
        {
            language_code: "hi",
            language_name: "Hindi"
        },
        {
            language_code: "ms",
            language_name: "Malay"
        },
    ],
    selected_language: "en"
};

const selectGameLaunchLanguageStateSlice = createSlice({
    name: 'game_launch_language',
    initialState: initialState,
    reducers: {
        setLanguageList: (state, action) => {
            state.game_launch_language_list = action.payload;
        },
        setSelectedLanguage: (state, action) => {
            state.selected_language = action.payload;
        },
        resetLanguage: (state) => {
            state.selected_language = "en";
        }
    }
});

export const { setLanguageList, setSelectedLanguage, resetLanguage } = selectGameLaunchLanguageStateSlice.actions;

export default selectGameLaunchLanguageStateSlice.reducer;